import logoDefault from "../assets/img_spin/logo.png";
import logoCbr from "../assets/img_spin/logo-cbr.png";

export function isColorBlockRun(hostname = window.location.hostname) {
  return /color-block-run\.com/.test(hostname);
}

export function getLogoSrc(hostname = window.location.hostname) {
  if (isColorBlockRun(hostname)) {
    return logoCbr;
  }
  return logoDefault;
}



// WEBPACK FOOTER //
// ./src/utils/logo.js